import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import withStyles from '@mui/styles/withStyles';
// import withFormatMessage from '../../../organisms/withFormatMessage.js';
// import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import withRouter from '../../../organisms/withRouter.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import {sysErr} from '../../../../common/commonGmn.js';
import {renderTextField} from '../../../atoms/CustomPart.js';
// import {reduxForm, getFormValues} from 'redux-form';
import {
  Typography,
} from '@mui/material';

const styles = (theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    height: 'auto',
    idth: '95%',
    overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },

});

// 一覧
const mdHistoryViews = [
  {binding: 'moDasiUserId', header: '持出者', dataType: 'String', width: 150, readOnly: true},
  {binding: 'moDasiYMD', header: '持出日時', dataType: 'String', width: 180, readOnly: true},
  {binding: 'dataKizyoUserId', header: '解除者', dataType: 'String', width: 150, readOnly: true},
  {binding: 'dataKizyoDate', header: '解除日時', dataType: 'String', width: 180, readOnly: true},
];

class MdHistory extends React.Component {
  constructor(props) {
    super(props);
    // 一覧Ref作成
    this.gridRef1 = React.createRef();
  }

  closeModal = () => {
    console.log('close');
    this.props.doCloseModal();
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let mdHistoryList = [];
    let headerData = {customerName: '', supplyPointNo: ''};
    mdHistoryList = [
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/19 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/19 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/18 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/18 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/17 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/17 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/16 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/16 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/15 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/15 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/15 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/15 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/14 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/14 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/13 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/13 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/12 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/12 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/11 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/11 00:00 23'},
      {moDasiUserId: '田中  一郎', moDasiYMD: '2026/12/10 00:00 23', dataKizyoUserId: '田中  一郎', dataKizyoDate: '2027/12/10 00:00 23'},

    ];
    headerData['supplyPointNo']='1234567890123456789012';
    headerData['customerName']='田中 一郎';
    // データを画面に設定
    this.props.doSetInitValues(headerData);
    if (this.gridRef1.current) {
      // 変更前リストデータを画面に設定
      this.gridRef1.current.setItemsSource(mdHistoryList);
    }
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  async componentDidUpdate() {
    try {
      if (this.gridRef1.current && this.state.modaltype ==='Approval') {
        this.getInitializeData();
      } else {
        this.setState({
          modaltype: 'Approval',
        });
      }
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 承認状況描画
   * @return {*}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: '1450px', height: 'auto', width: 'auto', marginTop: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
    };
    // 一覧定義取得
    let viewElems = [];
    if (mdHistoryViews) {
      for (const view of mdHistoryViews) {
        let viewElem;
        if (view.type === 'Select') {
          break;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef1} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }


  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="customerName" item xs={12} sm={5}>
            <Field
              id="customerName"
              name="customerName"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="お客さま名"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: true,
              }}
            >
            </Field>
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={5}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="供給地点特定番号"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: true,
              }}
            >
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes, openState, handleClose} = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>データ持出履歴</Typography>
          <div style={{marginBottom: '10px'}} />
          {this.renderCondition()}
          {/* <div style={{marginBottom: '10px'}} /> */}
          {this.renderTable()}
          <div style={{marginBottom: '10px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>閉じる</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

MdHistory.propTypes = {
  classes: PropTypes.object,
  modalInfo: PropTypes.object,
  content: PropTypes.object,
  doCloseModal: PropTypes.func,
  handleClose: PropTypes.func,
  handleExec: PropTypes.func,
  doSetInitValues: PropTypes.func,
  openState: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  modalInfo: state.common.modalInfo,
});

const mapDispatchToProps = {
  doCloseModal: commonOperations.doCloseModal,
  doSetInitValues: commonOperations.doSetInitValues,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(MdHistory)),
);
